<template>
  <div class="card-wrapper">
    <div class="card section" ref="card" v-bind:class="cardClass">
      <div class="inner">

        <div v-if="cardError" class="no-results">
          <p>Sorry, there are no results to match your filters</p>
        </div>

        <a
          class="close"
          v-on:click="closeModal"
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" fill="#fff">
            <path class="st0" d="M10.7 12c-.3 0-.6-.1-.9-.4L.4 2.2C-.1 1.7-.1.9.4.4s1.3-.5 1.8 0l9.5 9.5c.5.5.5 1.3 0 1.8-.3.2-.6.3-1 .3z"/>
            <path class="st0" d="M1.3 12c-.3 0-.6-.1-.9-.4-.5-.5-.5-1.3 0-1.8L9.9.3c.5-.5 1.3-.5 1.8 0s.5 1.3 0 1.8l-9.5 9.5c-.3.3-.6.4-.9.4z"/>
          </svg>
        </a>

        <h2 v-if="event">{{ event }}</h2>

        <div class="card__data" v-if="!cardError">

          {{ feelings.labels }}
          <div class="data">
            <ul class="results">
              <li class="item">
                <h3>Plans begin at age:</h3>
                <span class="result">{{ dynamicAge }} years old</span>
              </li>
              <li class="item" v-if="this.milestone">
                <h3>Milestone occurs at age:</h3>
                <span class="result">{{ milestone }} years old<span v-if="this.caveat" class="caveat-asterisk">*</span>
                </span>
              </li>
              <li class="item" v-if="this.planToAction">
                <h3>From plan to action takes:</h3>
                <span class="result">{{ planToAction }} years</span>
              </li>
              <li class="item" v-if="this.costLabel">
                <h3>{{ costLabel }}</h3>
                <span class="result">{{ costValue }}<span class="caveat-asterisk">**</span></span>
              </li>
              <li class="item" v-if="this.ageCaveat">
                <h3><span class="caveat-asterisk">*</span>{{ ageCaveat }}</h3>
              </li>
            </ul>
          </div>

          <div class="charts">
            <ul class="tabs">
              <li class="tab" v-on:click="activetab=1" v-bind:class="[ activetab === 1 ? 'active' : '' ]">
                <a href="#">Associated feelings</a>
              </li>
              <li class="tab" v-on:click="activetab=2" v-bind:class="[ activetab === 2 ? 'active' : '' ]">
                <a href="#">Personal approach</a>
              </li>
              <li class="tab" v-if="chartDataCost.labels.length > 0" v-on:click="activetab=3" v-bind:class="[ activetab === 3 ? 'active' : '' ]">
                <a href="#">Associated costs</a>
              </li>
            </ul>

            <div class="content">
              <div v-if="activetab === 1" class="tabcontent">

                  <chart
                    v-bind:data="chartDataFeelings"
                    v-bind:options="chartOptionsBar"
                    class="chart__item"
                  >
                  </chart>

              </div>
              <div v-if="activetab === 2" class="tabcontent">
                <div>
                  <chart
                    v-bind:data="chartDataAttitude"
                    v-bind:options="chartOptionsBar"
                    class="chart__item"
                  >
                  </chart>
                </div>
              </div>
              <div v-if="activetab === 3" class="tabcontent">
                <chart-line
                  v-bind:data="chartDataCost"
                  v-bind:options="chartOptionsLine"
                  class="chart__item"
                >
                </chart-line>
                <p class="caveat caveat--chart" v-html="this.chartCaveat"></p>
                <p class="caveat caveat--chart" v-html="this.subheading"></p>
              </div>
            </div>
          </div>
        </div>

        <p class="caveat" v-if="this.caveat">*Overall number, it is not representative of the filtered data. <span v-html="this.caveat"></span></p>
        <p class="caveat" v-if="this.spendCaveat">**<span v-html="this.spendCaveat"></span></p>
      </div>
    </div>
  </div>
</template>

<script>
import { Bus } from '@/components/Bus'
import { mapGetters } from 'vuex'
import Chart from '@/components/Chart'
import Line from '@/components/ChartLine'
import data from '@/data/data.json'

  window.bus = Bus;

export default {
  name: 'Modal',
  props: {

  },
  components: {
    'chart': Chart,
    'chart-line': Line
  },
  data () {
    return {
      cardActive: false,
      cardError: false,
      info: data.charts.info,
      activetab: 1,
      charts: data.charts,
      chartDataFeelings: {
        labels: [],
        datasets: [
          {
            type: 'horizontalBar',
            backgroundColor: '#E3105D',
            data: []
          }
        ]
      },
      chartDataAttitude: {
        labels: [],
        datasets: [
          {
            type: 'horizontalBar',
            backgroundColor: '#E3105D',
            data: []
          }
        ]
      },
      chartDataCost: {
        labels: [],
        datasets: [
          {
            type: 'line',
            data: [],
            backgroundColor: 'rgba(0,0,0,0)',
            borderColor: '#E3105D',
            pointBackgroundColor: '#fff',
            pointRadius: '5',
            pointHitRadius: '5',
            pointHoverRadius: '5'
          }
        ]
      },
      chartOptionsLine: {
        legend: {
          display: false
        },
        responsive: true,
        maintainAspectRatio: false,
        tooltips: {
          backgroundColor: '#199FD2',
          displayColors: false,
          bodyFontSize: 14,
          callbacks: {
            label: function (tooltipItem) {
              return '£' + tooltipItem.yLabel
            }
          }
        },
        scales: {
          yAxes: [{
            ticks: {
              beginAtZero: false
            }
          }]
        },
        title: {
          display: true,
          text: '',
          position: 'top',
          fontColor: '#E3105D',
          fontFamily: "'Baskerville'",
          fontSize: 20,
          lineHeight: 1.4,
          fontStyle: 'normal'
        }
      },
      chartOptionsBar: {
        legend: {
          display: false
        },
        responsive: true,
        maintainAspectRatio: false,
        tooltips: {
          backgroundColor: '#199FD2',
          displayColors: false,
          bodyFontSize: 14,
          callbacks: {
            label: function (tooltipItem) {
              return tooltipItem.xLabel + '%'
            }
          }
        },
        scales: {
          yAxes: [{
            ticks: {
              beginAtZero: true,
              fontColor: '#345B81',
              fontSize: '14'
            },
            gridLines: {
              display: false,
              offsetGridLines: false
            },
            maxBarThickness: 20
          }],
          xAxes: [{
            ticks: {
              beginAtZero: true,
              fontColor: '#345B81',
              min: 0,
              fontSize: '14',
              callback: function (value) {
                return value + '%'
              }
            },
            gridLines: {
              display: false,
              offsetGridLines: false
            },
            maxBarThickness: 20
          }]
        }
      }
    }
  },
  computed: {
    ...mapGetters({
      dataName: 'getModalDataName'
    }),
    dynamicAge: function () {
      const name = this.$store.getters.getModalDataName.replace(/\s+/g, '-').toLowerCase()
      let ages = this.$store.getters.getFilteredAgeData

      if (name) {
        var rtn = ages.find(obj => obj.event === name).age
      }

      return rtn
    },
    milestone: function () {
      const name = this.$store.getters.getModalDataName.replace(/\s+/g, '-').toLowerCase()

      if (name) {
        return this.info[name].milestone
      }
    },
    costLabel: function () {
      const name = this.$store.getters.getModalDataName.replace(/\s+/g, '-').toLowerCase()

      if (name) {
        return this.info[name].cost.label
      }
    },
    costValue: function () {
      const name = this.$store.getters.getModalDataName.replace(/\s+/g, '-').toLowerCase()

      if (name) {
        return this.info[name].cost.value
      }
    },
    planToAction: function () {
      if (this.dynamicAge < this.milestone) {
        return (this.milestone - this.dynamicAge)
      } else {
        return null
      }
    },
    caveat: function () {
      const name = this.$store.getters.getModalDataName.replace(/\s+/g, '-').toLowerCase()

      Bus.$on('noResults', () => {
        return null
      })

      if (name) {
        return this.info[name].milestoneCaveat
      }
    },
    spendCaveat: function () {
      const name = this.$store.getters.getModalDataName.replace(/\s+/g, '-').toLowerCase()

      if (name) {
        return this.info[name].spendCaveat
      }
    },
    chartCaveat: function () {
      const name = this.$store.getters.getModalDataName.replace(/\s+/g, '-').toLowerCase()

      if (name) {
        return this.charts.cost[name].source
      }
    },
    subheading: function () {
      const name = this.$store.getters.getModalDataName.replace(/\s+/g, '-').toLowerCase()

      if (name) {
        return this.charts.cost[name].subheading
      }
    },
    ageCaveat: function () {
      const name = this.$store.getters.getModalDataName.replace(/\s+/g, '-').toLowerCase()

      if (name) {
        return this.info[name].caveat
      }
    },
    event: function () {
      return this.cardError ? false : this.$store.getters.getModalDataName
    },
    feelings: function () {
      return this.$store.getters.getActiveFeelings
    },
    attitude: function () {
      return this.$store.getters.getActiveAttitude
    },
    formatEvent: function () {
      const activeDataSet = this.$store.getters.getModalDataName
      return activeDataSet.replace(/\s+/g, '-').toLowerCase()
    },
    cost: function () {
      return this.$store.getters.getActiveCost
    },
    costTitle: function () {
      if (this.$store.getters.getActiveCostTitle !== undefined) {
        return this.$store.getters.getActiveCostTitle
      }
    },
    cardClass: function () {
      return {
        'active': this.cardActive,
        'card--no-results': this.cardError
      }
    }
  },
  methods: {
    closeModal: function () {
      this.cardActive = false
      Bus.$emit('closeModal')

      setTimeout(() => {
        this.resetActiveTab()
        this.cardError = false
      }, 600)
    },
    resetActiveTab: function () {
      this.activetab = 1
    },
    attitudeData: function () {
      const labels = []
      const values = []

      for (var key in this.attitude) {
        labels.push(computeLabel(this.attitude[key].label))
        values.push(String(this.attitude[key].value))
      }

      this.$set(this.chartDataAttitude, 'labels', labels)
      this.$set(this.chartDataAttitude.datasets[0], 'data', values)
    },
    feelingData: function () {
      const labels = []
      const values = []

      for (var key in this.feelings) {
        labels.push(computeLabel(this.feelings[key].label))
        values.push(String(this.feelings[key].value))
      }

      this.$set(this.chartDataFeelings, 'labels', labels)
      this.$set(this.chartDataFeelings.datasets[0], 'data', values)
    },
    costData: function () {
      const labels = []
      const values = []

      for (var key in this.cost) {
        labels.push(computeLabel(this.cost[key].label))
        values.push(String(this.cost[key].value))
      }

      this.$set(this.chartDataCost, 'labels', labels)
      this.$set(this.chartDataCost.datasets[0], 'data', values)

      this.chartOptionsLine.title.text = this.costTitle
    }
  },
  mounted: function () {
    Bus.$on('openModal', () => {
      this.feelingData()
      this.attitudeData()
      this.costData()
      this.cardActive = true
      Bus.$emit('openChart')
    })

    Bus.$on('noResults', () => {
      this.cardActive = true
      this.cardError = true
    })
  }
}

  function computeLabel(labelText) {
    if (window.matchMedia('(max-width:900px)').matches && labelText.split(" ").length > 1) {
      //TODO more efficient solution can be done.
      var splitLabelSize = labelText.indexOf(" ", Math.floor(labelText.length / 2));

      if (splitLabelSize === -1) {
        splitLabelSize = labelText.lastIndexOf(" ");
      };

      var p1 = labelText.substr(0, splitLabelSize + 1).trim();
      var p2 = labelText.substr(splitLabelSize + 1, labelText.length);
      return [p1, p2];
    } else {
      return String(labelText);
    }
  }

</script>

<style lang="scss" scoped>

@import '../styles/core/vars.scss';
@import '../styles/core/mixins.scss';

.chart {
  margin-top: 30px;

  &__item {
    will-change: opacity;
  }
}

.tabcontent {
  padding: 30px 10px;
  border-radius: 20px;
  background-color: #fbfbfb;
}

.no-results {
  display: none;

  p{
    margin-bottom: 0;
  }
}

.caveat {
  font-size: 12px;
  color: $c-black;
  text-align: left;
  max-width: 780px;
  width: 100%;
  line-height: 1.4;
  margin-bottom: 0;
  margin-top: 20px;

  @include respond-to('medium') {
    position: relative;
    bottom: -10px;
  }

 /deep/ .link {
    color: $c-blue;
    text-decoration: underline;
  }

  &--chart {
    position: relative;
    bottom: 0;
    text-align: right;
    font-size: 10px;
    padding-right: 10px;

    .caveat-asterisk {

    }
  }

  &-asterisk {
    font-size: 16px;
    vertical-align: top;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/Modal.vue